module.exports = __webpack_public_path__ + "img/header-toggler.06dbe2ea.svg";